// pages/Dashboard.jsx
import ExploreAuthors from "../../components/home/ExploreAuthors";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <ExploreAuthors />
    </HomeLayout>
  );
}
